export default __webpack_public_path__ + "static/media/p2pfi.a3363eec.png";